import React, { useEffect } from 'react'
import { useParams, Switch, Route, useHistory } from 'react-router-dom'
import { getMakerData, MAKER_BASE_URL } from './Maker.utils';
import { MAKER_CHECKER_EVENT_LABEL_MLE, MAKER_CHECKER_EVENT_TYPES_MLE } from 'utils/constants/commonValues';
import { BreadCrumb, Timelinev1 } from 'components';
import BusinessTab from 'components/Onboarding/Mle/BusinessTab';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchBasicFormDataProcess } from 'containers/MerchantLegalEntity/redux/merchantLegalEntity.actions';
import { BUSINESS_SECTION_TYPE_MLE } from 'components/Onboarding/Mle/BusinessTab/contants';
import UobTab from 'components/Onboarding/Mle/UobTab';
import { filterSectionCheckerData } from 'components/MleMakerChecker/mleMakerChecker.utils';
import { MLE_ONBOARDING } from 'containers/Checker/checker.constants';
import { UBO_SECTION_TYPE } from 'components/Onboarding/Mle/UobTab/constant';
import { BASICFORM_MLE_UPDATE } from 'containers/MerchantLegalEntity/constants';

const baseUrl = MAKER_BASE_URL;
// Tab Definitions
const tabs = (id, makerRequestData) => ([
    {
        sectionType: MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase(),
        name: 'Business Details',
        component: (props) => {
            const {draftData} = props;
            
            if (props.formIdentityData) {
                const {uniqueIdentifier = '', intentId = '', formType = '', sectionType = ''} = props.formIdentityData;
                props.uniqueIdentifier = uniqueIdentifier;
                props.initialIntentId = intentId;
                props.formType = formType;
                props.sectionType = sectionType
            }
            return (
                <BusinessTab
                    {...props}
                    initialValues={draftData} // Pass the required data
                />
            )
        },
        nextPath: `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()}/${id}`,
        path: `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase()}/${id}`,
        previousPath: `${baseUrl}`,
        status: getMakerData(makerRequestData, MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase())?.isViewMode ? '' : 'Open',
        tabId: 1,
        permission: '',
        businessTabData: filterSectionCheckerData(makerRequestData?.childCheckerResponseList, MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase())
    },
    {
        sectionType: MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase(),
        name: 'Ownership Details',
        component: (props) => {
            const {draftData} = props;
            
            if (props.formIdentityData) {
                const {uniqueIdentifier = '', intentId = '', formType = '', sectionType = ''} = props.formIdentityData;
                props.uniqueIdentifier = uniqueIdentifier;
                props.initialIntentId = intentId;
                props.formType = formType;
                props.sectionType = sectionType
            }
            
            return (
                <UobTab
                        {...props}
                        initialValues={draftData}  
                />
            )
        },
        nextPath: `${baseUrl}`,
        path: `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()}/${id}`,
        previousPath: `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase()}/${id}`,
        status: getMakerData(makerRequestData, MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase())?.isViewMode ? '' : 'Open',
        tabId: 2,
        permission: '',
        businessTabData: filterSectionCheckerData(makerRequestData?.childCheckerResponseList, MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase())
    }
]);

const EditAndViewMaker = ({makerData, actions, merchantLegalEntityData}) => {
    
    const history = useHistory();
    const {tabname ,id} = useParams();
    const { basicSectionData, uboBasicDetails } = merchantLegalEntityData?.basicFormData;

    const makerRequestData = makerData.tableData.find(
        (tableData) =>
            (
                tableData.eventType === "MLE_ONBOARDING" ||
                tableData.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.business_update ||
                tableData.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.ownership_update
            ) &&
            String(tableData.makerRequestId) === String(id) // Ensure type consistency
    );

    useEffect(() => {
            if (makerRequestData?.eventType === MLE_ONBOARDING || 
                makerRequestData?.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.business_update) {
                    // fetching business details basic form data
                    let sectionType = BUSINESS_SECTION_TYPE_MLE;
                    let entityCode = BUSINESS_SECTION_TYPE_MLE;
                    let formType = null;
                    if (makerRequestData.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.business_update) {
                        formType = BASICFORM_MLE_UPDATE.business;
                        entityCode = null;
                    }
                    actions.fetchBasicFormDataProcess({sectionType, entityCode, formType});
                }
            
            if (makerRequestData?.eventType === MLE_ONBOARDING || 
                makerRequestData?.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.ownership_update) {
                // fetching ownership details basic form data
                let payload = {
                    sectionType: UBO_SECTION_TYPE,
                    entityCode: UBO_SECTION_TYPE
                };
                if (makerRequestData?.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.ownership_update) {
                    payload = {
                        sectionType: UBO_SECTION_TYPE,
                        formType: BASICFORM_MLE_UPDATE.ubo
                    }
                }
                actions.fetchBasicFormDataProcess(payload);
            }
        }, []);
    // const makerRequestData = fetchMakerRequest();
    
    if (!makerRequestData) {
        
        history.push(baseUrl);
        // return;    
    }

    const makerSteps = tabs(id, makerRequestData).filter(item => {
        if (makerRequestData?.eventType !== MLE_ONBOARDING && !item.businessTabData) {
            return false;
        }
        return true;
    });
    

  return (
        <div className='merchant-legal-entity-wrapper'>
            <div className="create-merchant-wrap" id="create-merchant-section">
                <div className="bread-crumbs">
                    <h3>Requested Approval</h3>
                    <BreadCrumb
                        breadCrumbs={[
                            {
                                name: 'Requested Approval',
                                link: '/maker',
                            },
                            {
                                name: (tabname) ? MAKER_CHECKER_EVENT_LABEL_MLE(tabname) :'',
                                link: '',
                            },
                        ]}
                    />
                </div>
                <div className="create-merchant">
                    <div className="left-section">
                        <Timelinev1
                            onboardingProcess={makerSteps}
                            isCreate={false}
                            heading="Requested Approval" 
                        />
                    </div>
                    <div className="right-section" style={{marginLeft: "10px"}}>
                        <Switch>
                            {makerSteps.map(tab => (
                                <Route exact path={tab.path} key={tab.tabId}>
                                    {tab.component({
                                        ...tab,
                                        ...getMakerData(
                                            makerRequestData,
                                            tab.sectionType,
                                            (tab.name === 'Business Details') ? basicSectionData : uboBasicDetails?.basicSectionData
                                        ),
                                        makerSteps,
                                        isMakerFlow: true,
                                        isReEditFlow: (makerRequestData?.eventType !== MLE_ONBOARDING) ? true :false,
                                        eventType: makerRequestData?.eventType,
                                    })}
                                </Route>
                            ))}
                        </Switch>

                        
                    </div>
                </div>
            </div>
        </div>
        
    );
}

const mapStateToProps = ({ makerData, merchantLegalEntityData }) => ({
    makerData,
    merchantLegalEntityData
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchBasicFormDataProcess
    }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAndViewMaker)
